
import React from 'react';
import { CategoryType } from '../../types';

interface DescriptionSelectorProps {
  category: CategoryType;
  description: string;
  setDescription: (val: string) => void;
  isCustom: boolean;
  setIsCustom: (val: boolean) => void;
  presets: string[];
}

const DescriptionSelector: React.FC<DescriptionSelectorProps> = ({ 
  category, description, setDescription, isCustom, setIsCustom, presets 
}) => {
  const hasPresets = presets.length > 0;

  return (
    <div className="space-y-1">
      <label className="block text-[9px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest ml-1">Descrição</label>
      {hasPresets && !isCustom ? (
        <div className="relative">
          <select 
            value={description} 
            onChange={(e) => e.target.value === 'Personalizado' ? (setIsCustom(true), setDescription('')) : setDescription(e.target.value)} 
            className="w-full bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg px-3 py-2.5 text-xs font-bold text-slate-800 dark:text-slate-100 outline-none focus:ring-4 focus:ring-blue-500/10 transition-all appearance-none shadow-sm pr-8"
          >
            <option value="" disabled>Opção...</option>
            {presets.map(desc => <option key={desc} value={desc}>{desc}</option>)}
            <option value="Personalizado">Digitar...</option>
          </select>
          <i className="fa-solid fa-chevron-down absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 pointer-events-none text-[9px]"></i>
        </div>
      ) : (
        <div className="relative">
          <input 
            required 
            value={description} 
            onChange={(e) => setDescription(e.target.value)} 
            className="w-full bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg px-3 py-2.5 text-xs font-bold text-slate-800 dark:text-slate-100 outline-none focus:ring-4 focus:ring-blue-500/10 transition-all placeholder:opacity-30 shadow-sm" 
            placeholder="Ex: Aluguel..." 
          />
          {hasPresets && (
            <button 
              type="button" 
              onClick={() => setIsCustom(false)} 
              className="absolute right-2 top-1/2 -translate-y-1/2 text-[7px] font-black uppercase text-blue-600 dark:text-blue-400 bg-white dark:bg-slate-900 px-2 py-1.5 rounded-lg shadow-sm border border-slate-100 dark:border-slate-700"
            >
              Lista
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default DescriptionSelector;
